var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4639_12292)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3327 2.66683H4.66602C4.29783 2.66683 3.99935 2.96531 3.99935 3.3335V12.6668C3.99935 13.035 4.29783 13.3335 4.66602 13.3335H11.3327C11.7009 13.3335 11.9993 13.035 11.9993 12.6668V3.3335C11.9993 2.96531 11.7009 2.66683 11.3327 2.66683ZM4.66602 1.3335C3.56145 1.3335 2.66602 2.22893 2.66602 3.3335V12.6668C2.66602 13.7714 3.56145 14.6668 4.66602 14.6668H11.3327C12.4373 14.6668 13.3327 13.7714 13.3327 12.6668V3.3335C13.3327 2.22893 12.4373 1.3335 11.3327 1.3335H4.66602ZM10.666 8.66683L7.99935 11.3335L5.33268 8.66683L6.26602 7.7335L7.33268 8.76683V6.00016H8.66602V8.76683L9.73268 7.7335L10.666 8.66683ZM9.66602 3.3335H6.33268V4.40016H9.66602V3.3335Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4639_12292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileIcon);
export default __webpack_public_path__ + "static/media/mobile-icon.f49c9d271aa167883b632a9a2c6e6ee8.svg";
export { ForwardRef as ReactComponent };